import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=15bb966d&scoped=true&"
import script from "./dataDictionary.vue?vue&type=script&lang=js&"
export * from "./dataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=15bb966d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bb966d",
  null
  
)

export default component.exports